export const BASE_URI = "https://react-eatable-api.herokuapp.com";
export const tokenKey = "eatable-token";
export const productsKey = "eatable-products";
export const cartKey = "eatable-cart";
